/** Stable, machine-readable error codes callers can branch on instead of matching prose. */
export const ALERT_EMAIL_ERROR_CODES = {
  NOT_FOUND: 'ALERT_EMAIL_NOT_FOUND',
  DUPLICATE: 'ALERT_EMAIL_DUPLICATE',
} as const;

export type AlertEmailErrorCode = (typeof ALERT_EMAIL_ERROR_CODES)[keyof typeof ALERT_EMAIL_ERROR_CODES];
